module.exports = __webpack_public_path__ + "static/media/icon5.b5a0c6fa.svg";